import {
	Button,
	Col,
	Collapse,
	Divider,
	Form,
	Input,
	InputNumber,
	Radio,
	Row,
	Select,
	Typography,
} from 'antd';
import { FC, Fragment } from 'react';
import FBDHVisitReportAttendee from './VisitReportApproval.Office.Attendee';
import FBDHVisitReportDetail from './VisitReportApproval.Office.Detail';
import FBDHVisitReportUnits from './VisitReportApproval.Office.Unit';
import ANTD_DEFAULT_PROPS from '@/libs/antd/props';
import { useFBDHVisitReportApprovalPage } from './VisitReportApproval';
import {
	MarketingAspect,
	OfficeObservationWarehouse,
} from '@/libs/fleet-api/services/types';
import { useForm } from '@/libs/antd/form';
import FBDHisitReportSalesMethod from './VisitReportApproval.Office.Method';
import FBDHVisitReportPaymentSystem from './VisitReportApproval.Office.Payment';
import FBDHVisitReportCompetitor from './VisitReportApproval.Office.Competitor';
import FBDHVisitReportBouwheer from './VisitReportApproval.Office.Bouwheer';
import FBDHVisitReportWarehouse, {
	useWarehouseForm,
} from './VisitReportApproval.Office.Warehouse';
import FBDHVisitReportSparePart from './VisitReportApproval.Office.SparePart';
import FBDHVisitReportInventory from './VisitReportApproval.Office.Inventory';
import { OfficeMaterialOwnership } from '@/libs/fleet-api/enums';
import FBDHVisitReportParetoSupplier from './VisitReportApproval.Office.ParetoSupplier';
import FBDHVisitReportParetoReceivable from './VisitReportApproval.Office.Pareto';
import FBDHVisitReportOfficeCollateralUnit from './VisitReportApproval.Office.CollateralUnit';
import FBDHVisitReportPhoto from './VisitReportApproval.Office.Photo';
import rule from '@/libs/antd/rules';
import { inputCurrency } from '@/libs/antd/input-number';

const FBDHVisitReportApprovalOffice: FC<{
	onNext: () => void;
}> = ({ onNext }) => {
	const { officeObservation } = useFBDHVisitReportApprovalPage();
	const { marketingAspect, warehouse } = officeObservation;
	const marketingAspectForm = useForm<MarketingAspect>();
	const warehouseForm = useWarehouseForm();

	return (
		<Fragment>
			<Collapse
				defaultActiveKey={[]}
				items={[
					{
						key: 'technicalAspect',
						label: 'Aspek Teknis',
						children: (
							<Fragment>
								<FBDHVisitReportAttendee />
								<FBDHVisitReportDetail />
								<FBDHVisitReportUnits />
								<Divider />
								<Row gutter={[20, 20]}>
									<Col span={5}>
										<strong>FRM Notes</strong>
									</Col>
									<Col span={19}>
										{officeObservation?.technicalAspect.technicalAspectNotes ??
											'-'}
									</Col>

									<Col span={5}>
										<strong>CCA Notes</strong>
									</Col>
									<Col span={19}>
										{officeObservation?.technicalAspect
											.technicalAspectVerificationNotes ?? '-'}
									</Col>
								</Row>
							</Fragment>
						),
					},
					{
						key: 'marketingAspect',
						label: 'Aspek Pemasaran',
						children: (
							<Fragment>
								<Form
									{...ANTD_DEFAULT_PROPS.FORM}
									form={marketingAspectForm.form}
									name="productOffer"
									initialValues={
										{
											productOffer: marketingAspect?.productOffer,
										} as MarketingAspect
									}
								>
									<Row gutter={[20, 40]}>
										<Col span={12}>
											<Form.Item
												name={marketingAspectForm.fieldName('productOffer')}
												label="Produk/Jasa yang dipasarkan"
											>
												<Input disabled />
											</Form.Item>
										</Col>
									</Row>
								</Form>
								<Divider />

								<FBDHisitReportSalesMethod />
								<FBDHVisitReportPaymentSystem />

								<Form
									{...ANTD_DEFAULT_PROPS.FORM}
									form={marketingAspectForm.form}
									name="isOtherBusiness"
									initialValues={
										{
											isOtherBusiness: marketingAspect?.isOtherBusiness,
											otherBusiness: marketingAspect?.otherBusiness,
											otherBusinessPortion:
												marketingAspect?.otherBusinessPortion,
										} as MarketingAspect
									}
								>
									<Row gutter={[20, 40]}>
										<Col span={12}>
											<Form.Item
												name={marketingAspectForm.fieldName('isOtherBusiness')}
												label="Apakah terdapat usaha lain?"
											>
												<Radio.Group style={{ marginTop: 10 }}>
													<Radio
														value={true}
														disabled
													>
														Ya
													</Radio>
													<Radio
														value={false}
														disabled
													>
														Tidak
													</Radio>
												</Radio.Group>
											</Form.Item>
										</Col>
									</Row>
									<Divider />
									{marketingAspectForm.value?.isOtherBusiness && (
										<Fragment>
											<Row gutter={[20, 40]}>
												<Col span={12}>
													<Form.Item
														name={marketingAspectForm.fieldName(
															'otherBusiness',
														)}
														label="Sebutkan Usaha Lain"
													>
														<Input disabled />
													</Form.Item>
												</Col>
												<Col span={12}>
													<Form.Item
														name={marketingAspectForm.fieldName(
															'otherBusinessPortion',
														)}
														label="Porsi"
													>
														<InputNumber
															suffix="%"
															disabled
														/>
													</Form.Item>
												</Col>
											</Row>
											<Divider />
										</Fragment>
									)}
								</Form>

								<FBDHVisitReportCompetitor />
								<FBDHVisitReportBouwheer />
								<Divider />

								<Row gutter={[20, 20]}>
									<Col span={5}>
										<strong>FRM Notes</strong>
									</Col>
									<Col span={19}>
										{officeObservation?.marketingAspect.marketingAspectNotes ??
											'-'}
									</Col>

									<Col span={5}>
										<strong>CCA Notes</strong>
									</Col>
									<Col span={19}>
										{officeObservation?.marketingAspect
											.marketingAspectVerificationNotes ?? '-'}
									</Col>
								</Row>
							</Fragment>
						),
					},
					{
						key: 'warehouse',
						label: 'Workshop/Gudang',
						children: (
							<Fragment>
								<FBDHVisitReportWarehouse />
								<FBDHVisitReportSparePart />
								<FBDHVisitReportInventory />

								<Form
									{...ANTD_DEFAULT_PROPS.FORM}
									name="materialOwnership"
									form={warehouseForm.form}
									labelCol={{
										span: 10,
									}}
									initialValues={
										{
											materialOwnershipTypeId:
												warehouse?.materialOwnershipType?.id,
											materialOwnershipPortion:
												warehouse?.materialOwnershipPortion,
										} as OfficeObservationWarehouse<'payload'>
									}
								>
									<Row gutter={[20, 40]}>
										<Col span={12}>
											<Form.Item
												name={warehouseForm.fieldName([
													'materialOwnershipTypeId',
												])}
												label="Kepemilikan Bahan"
												labelCol={{ span: 10 }}
											>
												<Select
													disabled
													options={[
														{
															label: warehouse.materialOwnershipType.value,
															value: warehouse.materialOwnershipType.id,
														},
													]}
												/>
											</Form.Item>
										</Col>
										{warehouseForm.value?.materialOwnershipTypeId ===
											OfficeMaterialOwnership.Konsinyasi && (
											<Col span={12}>
												<Form.Item
													name={warehouseForm.fieldName([
														'materialOwnershipPortion',
													])}
													label="Berapa % ?"
													labelCol={{ span: 10 }}
												>
													<InputNumber
														min={0}
														disabled
													/>
												</Form.Item>
											</Col>
										)}
									</Row>
									<Divider />
								</Form>

								<FBDHVisitReportParetoSupplier />
								<Typography.Title level={3}>
									List Piutang Pareto
								</Typography.Title>
								<Form
									{...ANTD_DEFAULT_PROPS.FORM}
									style={{ marginBottom: 20 }}
								>
									<Row gutter={[20, 40]}>
										<Col span={12}>
											<Form.Item
												label="Total Piutang"
												labelCol={{ span: 10 }}
												rules={[rule.required()]}
											>
												<InputNumber
													{...inputCurrency}
													value={warehouse?.totalReceivables}
													disabled
												/>
											</Form.Item>
										</Col>
									</Row>
								</Form>
								<FBDHVisitReportParetoReceivable />
								<Divider />

								<Row gutter={[20, 20]}>
									<Col span={5}>
										<strong>FRM Notes</strong>
									</Col>
									<Col span={19}>
										{officeObservation?.warehouse.warehouseNotes ?? '-'}
									</Col>

									<Col span={5}>
										<strong>CCA Notes</strong>
									</Col>
									<Col span={19}>
										{officeObservation?.warehouse.warehouseVerificationNotes ??
											'-'}
									</Col>
								</Row>
							</Fragment>
						),
					},
					{
						key: 'collateral',
						label: 'Agunan',
						children: (
							<Fragment>
								<FBDHVisitReportOfficeCollateralUnit />
								<Divider />

								<Row gutter={[20, 20]}>
									<Col span={5}>
										<strong>FRM Notes</strong>
									</Col>
									<Col span={19}>
										{officeObservation?.collateral.collateralNotes ?? '-'}
									</Col>

									<Col span={5}>
										<strong>CCA Notes</strong>
									</Col>
									<Col span={19}>
										{officeObservation?.collateral.collateralNotes ?? '-'}
									</Col>
								</Row>
							</Fragment>
						),
					},
				]}
			/>

			<FBDHVisitReportPhoto />
			<Button
				type="primary"
				style={{
					width: 200,
					display: 'block',
					marginLeft: 'auto',
					marginTop: 20,
				}}
				onClick={() => {
					onNext?.();
				}}
			>
				NEXT
			</Button>
		</Fragment>
	);
};

export default FBDHVisitReportApprovalOffice;
